import type { ComponentProps } from 'react'
import { StyleSheet, Text } from 'react-native'
import { mesaColorNames, spacing, typography } from '@/src/common/theme'

export function TopLevelHeader(props: ComponentProps<typeof Text>) {
  return (
    <Text
      {...props}
      style={StyleSheet.flatten([
        {
          backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
          paddingBottom: spacing.base,
          paddingHorizontal: spacing['4'],
        },
        typography['heading/heading3'],
        props.style,
      ])}
    />
  )
}

export const transactionsTopLevelHeader = <TopLevelHeader>Transactions</TopLevelHeader>
